import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Products from '../pages/products/Products'
import Productos from '../views/productos/Productos'
import Transport from '../pages/products/Transport'
import Insumos from '../pages/products/Insumos'
import Aires from '../pages/products/Aires'

export default function ProductsRoutes() {
  return (
    <Routes>
        <Route path='/' element={<Products />} />
        <Route path='/insumos' element={<Insumos />} />
        <Route path='/insumos/:rubro' element={<Productos />} />
        <Route path='/transporte' element={<Transport />} />
        <Route path='/aires' element={<Aires />} />
    </Routes>
  )
}
